import React, { useState, useRef } from "react";
import "./TransformTimeline.css";
import "./EnhancedTransformTimeline.css";
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';
import { MobileTimelineLayout } from "./Layouts/Mobile";
import { DesktopTimelineLayout } from "./Layouts/Desktop";

export const EnhancedTransformTimeline = ({ settings }) => {
    const isMobile = useMobileBreakpoint(settings.settings.mobile_breakpoint || 768);
    const sectionRef = useRef<HTMLDivElement>(null);
    const stickyScrollRef = useRef<HTMLDivElement>(null);
    const globals = settings.settings.globals || {};

    // State for scroll progress tracking
    const [scrollProgress, setScrollProgress] = useState(0);
    const [activeSection, setActiveSection] = useState(0);

    // Derive items from settings
    const items = settings.settings.blocks.map((item) => ({
        title: item.settings.name,
        description: item.settings.description,
        icon: item.settings.icon,
    }));
    
    // Get configurable content from settings
    const rightSideContent = {
        title: settings.settings.section.right_side_title || "Accelerate Your Transformation",
        description: settings.settings.section.right_side_description,
        buttonText: settings.settings.section.right_side_button_text || "Learn about MindArc Services",
        buttonUrl: settings.settings.section.right_side_button_url || "#",
        pulseSettings: { ...globals.pulse_animation }
    };
    
    // Configuration for the sticky scroll behavior (desktop only)
    const stickyScrollSettings = {
        triggerPoint: 0,
        duration: 1.2,
        sectionHeight: 100,
        disableMobile: true, // Disable for mobile since we have separate layout
        mobileBreakpoint: settings.settings.mobile_breakpoint || 768,
        scrollIndicator: false,
        smoothScroll: true,
        bottomOffset: 0,
        onSectionChange: (section, progress) => {
            setActiveSection(section);
            const totalSections = items.length;
            const overallProgress = (section + progress) / totalSections;
            setScrollProgress(Math.min(1, Math.max(0, overallProgress)));
        }
    };

    return (
        <div className="transform-timeline-enhanced-wrapper relative" ref={sectionRef}>
            {/* Top gradient/blush element */}
            <div className="absolute top-0 left-0 w-[300px] h-[200px] bg-gradient-radial from-[#899B30]/20 to-transparent z-10 opacity-50"/>
          
            <div className="w-full mx-auto relative">
                {isMobile ? (
                    <MobileTimelineLayout 
                        items={items}
                        rightSideContent={rightSideContent}
                        scrollProgress={scrollProgress}
                    />
                ) : (
                    <DesktopTimelineLayout 
                        items={items}
                        rightSideContent={rightSideContent}
                        stickyScrollSettings={stickyScrollSettings}
                        stickyScrollRef={stickyScrollRef}
                    />
                )}
            </div>

        </div>
    );
};

export default EnhancedTransformTimeline;